export var InstructionType;
(function (InstructionType) {
    InstructionType["BATCH"] = "batch";
    InstructionType["SEGMENT"] = "segment";
    InstructionType["RELATION"] = "relation";
    InstructionType["METADATA"] = "metadata";
})(InstructionType || (InstructionType = {}));
